
export const userNameFrom = user => {
	return user ? (
		user.profile_type == 1 && user.company?.name && user.company?.status == 2 && user.company.name
			? user.company.name
			: user.name
		) : 'Deleted User'
}

export const avatarFrom = (user, key) => {
	if(!key) key = '100_100_crop'
	const avatar = user?.profile_type == 1 && user?.company?.meta?.image?.urls && user.company.meta.image.urls[key]
        ? user.company.meta.image.urls[key]
        : (
			user?.gravatar
				? user?.gravatar
				: '/images/user-slash.png'
		)
	return avatar
}

